import { FC, ReactNode } from 'react';

interface IProps {
  width: number | string;
  height: number | string;
  fill: string;
  viewBox?: string;
  children: ReactNode;
}

/* Иконка загрузки */
export const IconSVG: FC<IProps> = (props) => {
  const { width, height, fill, viewBox = '', children } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox || `0 0 ${width} ${height}`}
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      {children}
    </svg>
  );
};
